@for (row of get(relatedContentRow, 'rows', []); track row) {
  @if (get(row, 'related_content', '')) {
    <section [class.gray-bg]="get(row, 'related_content.gray_background')">
      <div class="cms-related-content d-flex flex-column container">
        <div class="d-flex flex-row justify-content-between">
          <h2>Related Content</h2>
        </div>
        <div
          class="d-flex flex-row justify-content-between align-items-center pt-2"
          [class.case-study-title]="activeCategoryName === 'Case Studies'"
          >
          <div id="nav-links" class="d-flex flex-row flex-wrap justify-content-start">
            @for (category of categories; track category) {
              <div (click)="onChosenTitle(category)">
                @if (!isEmpty(getCategoryPosts(row?.related_content, category))) {
                  <div
                    class="title"
                    [class.active]="category == activeCategoryName"
                    tabindex="0"
                    role="button"
                    (keydown.enter)="onChosenTitle(category)"
                    (keydown.space)="onChosenTitle(category); $event.preventDefault()"
                    >
                    <span>{{ category }}</span>
                    <div class="block"></div>
                  </div>
                }
              </div>
            }
          </div>
          @if (activeCategoryName === 'Blog' || activeCategoryName === 'Case Studies') {
            <div
              class="button-container"
              >
              @switch (activeCategoryName) {
                @case ('Blog') {
                  <button-component
                        [buttonOptions]="{
                            text: 'View more blogs',
                            internalLink: '/blog',
                            type: 'primary',
                            iconPosition: 'right',
                            iconName: 'chevron-right',
                            innerTabIndex: -1
                        }"
                  ></button-component>
                }
                @case ('Case Studies') {
                  <button-component
                        [buttonOptions]="{
                            text: 'View more case studies',
                            internalLink: '/case-studies',
                            type: 'primary',
                            class: 'case-studies-button',
                            iconPosition: 'right',
                            iconName: 'chevron-right',
                            innerTabIndex: -1
                        }"
                  ></button-component>
                }
              }
            </div>
          }
        </div>
        <div class="cards grid partial-grid container-padless" [class.case-study-grid]="activeCategoryName === 'Case Studies'">
          @for (entry of getCategoryPosts(row?.related_content).slice(0, isNarrow ? 4 : 3); track entry) {
            <div
              class="card-container g-col-lg-4 g-col-12 d-flex flex-row align-items-center"
              [class.border-bottom]="isNarrow && activeCategoryName !== 'Case Studies'"
              >
              <!-- Case Study Card Template -->
              @if (activeCategoryName === 'Case Studies') {
                <div class="case-studies-card-container fx-row card">
                  <a [routerLink]="entry?.routerLink || entry?.url || '/case-studies/' + entry?.landing_page_url" class="fx-row fx-fill-remaining">
                    <!-- Case Study Image -->
                    <div class="image-container fx-row-h-center fx-row-v-center">
                      <img
                        [src]="entry?.feature_image?.url || entry?.preview_image?.href || entry?.thumbnail_image"
                        [alt]="entry?.feature_image?.title || entry?.preview_image?.title || entry?.title || 'Case study thumbnail'"
                        [attr.loading]="isBrowser ? 'lazy' : null"
                        />
                    </div>
                    <!-- Case Study Title -->
                    <div class="info-container fx-col p-3">
                      <div class="card-header fx-col mb-2">
                        <h4 class="m-0 font-md">
                          {{ entry?.title }}
                        </h4>
                      </div>
                      <!-- Case Study Tags -->
                      <div class="tag-container fx-row fx-wrap">
                        @for (tag of entry?.tags?.slice(0, 3); track tag) {
                          <div
                            class="tag"
                            tabindex="0"
                            role="button"
                            (click)="openTagSearch(tag, $event)"
                            (keydown.enter)="openTagSearch(tag, $event)"
                            (keydown.space)="openTagSearch(tag, $event); $event.preventDefault()"
                            >
                            <p class="font-sm bold m-0">
                              {{ tag }}
                            </p>
                          </div>
                        }
                        <!-- Simple +N indicator if more than 3 tags -->
                        @if (entry?.tags?.length > 3) {
                          <div class="tag overflow-indicator">
                            <p class="font-sm bold m-0">+{{ entry?.tags?.length - 3 }}</p>
                          </div>
                        }
                      </div>
                      <div class="date-time-container fx-col fx-row-h-space-between pt-1">
                        <p class="m-0 font-sm weight-400">
                          {{ entry?.date | date: 'longDate' }}
                        </p>
                        <span class="fx-row fx-row-v-center">
                          <i-feather name="clock"></i-feather>
                          <p class="m-0 font-sm weight-400">{{ +entry?.character_count | readTime }}</p>
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              }
              <!-- Use resource-card-related-card for other content types -->
              @if (activeCategoryName !== 'Case Studies') {
                <app-resource-card-related-card
                  class="card"
                  [entry]="entry"
                        [relatedContentTileData]="{
                            title: entry?.title,
                            categoryTitle: entry?.blog_category?.[0]?.title || entry?.type?.[0]?.title,
                            image: entry?.feature_image?.url || entry?.preview_image?.href,
                            imageTitle: entry?.feature_image?.title || entry?.preview_image?.title,
                            date: entry?.date,
                            link: entry?.routerLink || entry?.url,
                            entry: entry,
                            isRelatedContent: true,
                            hideTimeNarrow: true
                        }"
                ></app-resource-card-related-card>
              }
            </div>
          }
        </div>
      </div>
    </section>
  }
  @if (get(row, 'related_content.split_line', '')) {
    <hr class="m-0 mb-3" />
  }
}
